import { render, staticRenderFns } from "./BankWire.vue?vue&type=template&id=5ca7b136&"
import script from "./BankWire.vue?vue&type=script&lang=js&"
export * from "./BankWire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports